import RequestPrescreenerClientPreferencesController from 'client-portal/controllers/-request/prescreener-client-preferences';

export default class WidgetPrescreenerClientPreferences extends RequestPrescreenerClientPreferencesController {}
